<template>
  <div class="row mb-5">
    <div class="col-12">
      <h4 class="text-primary mb-3">Adjudicatario</h4>
    </div>
    <div class="col-6 mt-3">
      <div>
        <strong>Rut</strong>
        <div class="ml-3">
          {{bidder.rut}}
        </div>
      </div>
    </div>
    <div class="col-6 mt-3">
      <div>
        <strong>Nombre</strong>
        <div class="ml-3">
          {{bidder.nombre}}
        </div>
      </div>
    </div>
    <div class="col-6 mt-3">
      <div>
        <strong>Giro</strong>
        <div class="ml-3">
          {{bidder.giro}}
        </div>
      </div>
    </div>
    <div class="col-6 mt-3">
      <div>
        <strong>Direccion</strong>
        <div class="ml-3">
          {{bidder.direccion}}
        </div>
      </div>
    </div>
    <div class="col-6 mt-3">
      <div>
        <strong>Comuna</strong>
        <div class="ml-3">
          {{bidder.comuna}}
        </div>
      </div>
    </div>
    <div class="col-6 mt-3">
      <div>
        <strong>Ciudad</strong>
        <div class="ml-3">
          {{bidder.ciudad}}
        </div>
      </div>
    </div>
    <div class="col-6 mt-3">
      <div>
        <strong>Correo</strong>
        <div class="ml-3">
          {{bidder.correo}}
        </div>
      </div>
    </div>
    <div class="col-6 mt-3">
      <div>
        <strong>Contacto</strong>
        <div class="ml-3">
          {{bidder.telefono}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    };
  },
  props: ['bidder']
};
</script>
<style>

</style>
